var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.5 7.333C2.5 4.664 4.664 2.5 7.333 2.5c2.67 0 4.834 2.164 4.834 4.833 0 1.307-.52 2.493-1.362 3.363-.02.015-.04.032-.059.05-.018.019-.035.038-.05.059-.87.843-2.056 1.362-3.363 1.362-2.669 0-4.833-2.164-4.833-4.834zm8.59 4.464c-1.015.854-2.326 1.37-3.757 1.37-3.221 0-5.833-2.612-5.833-5.834C1.5 4.112 4.112 1.5 7.333 1.5c3.222 0 5.834 2.612 5.834 5.833 0 1.431-.515 2.742-1.37 3.756l2.556 2.557c.196.196.196.512 0 .707-.195.196-.511.196-.707 0l-2.557-2.556z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/search.4a8a007d.svg";
export { ForwardRef as ReactComponent };